<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-3 align-items-center">
      <!-- Search Input -->
      <div class="col-md-8 position-relative">
        <input
          type="text"
          class="form-control ps-5 form-control-sm"
          :placeholder="$t('chapters.searchPlaceholder')"
          v-model="searchTerm"
          @input="handleSearch"
          style="padding-right: 12px;" 
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>
      
      <!-- Add Button -->
      <div class="col-md-4">
        <button 
          class="btn btn-secondary btn-sm w-100 d-flex align-items-center justify-content-center gap-2" 
          @click="$emit('add')"
        >
          <i class="fas fa-plus"></i>
          <span>{{ $t('chapters.addNewChapter') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { debounce } from 'lodash';

const searchTerm = ref('');
const emit = defineEmits(['search', 'add']);

const handleSearch = debounce(() => {
  emit('search', searchTerm.value);
}, 300);
</script>
